<!--- Componente PCInformacionSinRegistros  ---->
<!---
Descripción del componente y comportamiento:
---------------------------
- Muestra un icono que informa que no hay registros de volcado.

Eventos escuchados por el formulario:
-----------------------
-- XXXXXXX ->

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div class="div-componenteInformacionSinRegistros">
    <!-- No existen registros de volcado -->
    <div class="div-sinRegistrosDeMovimientos">
      <f7-row>
        <f7-col class="col-iconoListaVacia">
          <img
            src="@/static/icons/ic_emptyList.svg"
            width="126"
            height="111"
            alt="listaVaciaMobil"
          >
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col class="col-textoListaVacia">
          <span class="span-informacionSinMovimientos">
            {{ titulo ?? $t('infoWithoutMovements.noElements') }}
            <br>
            {{ subtitulo ?? $t('infoWithoutMovements.readCodeToStart') }}
          </span>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PCInformacionSinRegistros',

  props: {
    titulo: {
      type: String,
      default: null,
    },
    subtitulo: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.div-sinRegistrosDeMovimientos {
  background: var(--his-tierra-white);
  min-height: -webkit-fill-available;
  height: 100vh;
}

.span-informacionSinMovimientos {
  color: var(--his-ash-gray);
  font-size: 16px;
}

.col-iconoListaVacia {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.col-textoListaVacia {
  text-align: center;
}
</style>
